import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { Loader } from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'model/types/auth';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }: Readonly<GuardProps>) {
  const { authInProgress, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!isLoggedIn) {
      // Preserve both pathname and query parameters
      const fullPath = `${location.pathname}${location.search}`;
      navigate('login', {
        state: {
          from: fullPath
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  if (authInProgress) return <Loader />;

  return children;
}
